import api from './api';

export const applicantService = {
  // Get all applications
  getAll: async (params = {}) => {
    const queryString = new URLSearchParams(params).toString();
    const response = await api.get(`/applicants${queryString ? `?${queryString}` : ''}`);
    return response.data;
  },

  // Get single application (includes presigned URLs)
  getById: async (id) => {
    const response = await api.get(`/applicants/${id}`);
    return response.data;
  },

  // Get presigned URL for a specific file
  getFileUrl: async (id, fileType) => {
    const response = await api.get(`/applicants/${id}/file/${fileType}`);
    return response.data.url;
  },

  // Update application status
  updateStatus: async (id, status, notes) => {
    const response = await api.put(`/applicants/${id}/status`, { status, notes });
    return response.data;
  },

  // Add notes to application
  addNotes: async (id, notes) => {
    const response = await api.post(`/applicants/${id}/notes`, { notes });
    return response.data;
  },

  // Convert application to employee
  convertToEmployee: async (id, data) => {
    const response = await api.post(`/applicants/${id}/convert`, data);
    return response.data;
  },

  // Delete application
  delete: async (id) => {
    const response = await api.delete(`/applicants/${id}`);
    return response.data;
  }
};

export default applicantService;
